export type OfflineStatus = "preparing" | "ready" | "error" | "unsupported";

export const OFFLINE_STATUS_EVENT = "sww-oma-offline-status";
const READY_KEY = "sww-oma-offline-ready-v1";

function hasStoredReadyFlag(): boolean {
  try {
    return localStorage.getItem(READY_KEY) === "1";
  } catch {
    return false;
  }
}

export function initialOfflineStatus(): OfflineStatus {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return "unsupported";
  if (!navigator.onLine && hasStoredReadyFlag()) return "ready";
  return "preparing";
}

export function announceOfflineStatus(status: OfflineStatus): void {
  if (status === "ready") {
    try {
      localStorage.setItem(READY_KEY, "1");
    } catch {
      // The active service worker still provides offline access when storage flags are unavailable.
    }
  }
  window.dispatchEvent(new CustomEvent<OfflineStatus>(OFFLINE_STATUS_EVENT, { detail: status }));
}

export async function confirmActiveOfflineWorker(): Promise<void> {
  if (!("serviceWorker" in navigator)) {
    announceOfflineStatus("unsupported");
    return;
  }
  try {
    const registration = await navigator.serviceWorker.ready;
    if (registration.active) announceOfflineStatus("ready");
  } catch {
    announceOfflineStatus("error");
  }
}
